function testFun() {
  // alert('111调用成功');
  console.debug("已加载：DDD | testFun()");
}

function testFun2(code, octopus) {
  console.log(code);
  octopus.tips.debug("已加载：" + code + " | use us js -> testFun2");
}

// VUE外挂JS库注册，很关键
export {
  testFun, testFun2
}



// WEBPACK FOOTER //
// ./src/assets/js/us.js